import styled from 'styled-components';
import { Box, CircularProgress, Typography } from '@mui/material';

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: ${({ theme }) => theme.spacing(2)};
`;

export const Spinner = styled(CircularProgress)``;

export const Text = styled(Typography)`
  text-align: center;
  font-weight: 700 !important;
  color: ${({ theme }) => theme.palette.text.primary};
`;
